import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Home from "./Home";
import Contact from "./Contact";
import Specialists from "./Spescalists/Specialists";
import AddContact from "./AddContact";
import Documents from "./documents/Documents";
import News from "./News";
import Lifehacks from "./lifehacks/Lifehacks";
import SpecialistDetails from "./Spescalists/SpecialistDetails";
import DonationComponent from "./DonationComponent";
import ArticlesPage from "./lifehacks/Lifehacks";
import EntryRulesBrazil from "./lifehacks/EntryRulesBrazil";
import FlorianopolisLifeHacks from "./lifehacks/FlorianopolisLifehacks";
import MaternityHospitals from "./lifehacks/MaternityHoospitals";
import VisaExtension from "./documents/VisaExtension";
import ChildCitizenshipBrazil from "./documents/ChildCitizenship";
import ForChild from "./lifehacks/ForChild";
import BeachWaterQuality from "./lifehacks/BeachWaterQuality";
import SUSGuide from "./documents/SUSGuide";
import PrivacyPolicy from "./Privacy";
import Tourism from "./tourism/Tourism";
import FloripaGuide from "./tourism/FloripaGuide";
import WeatherWidget from "./WeatherWidget";
import Balneario from "./tourism/Balneario";
import BetoCarreroArticle from "./tourism/BetoCarrero";
import FloripaLocationsGuide from "./tourism/Locations";
import SitioDoMorango from "./tourism/SitioDoMorango";
import DriverLicenseBrazil from "./documents/DriverLicense";
import PetTravelGuide from "./documents/PetTravelGuide";
import CPFOnlineInstructions from "./documents/CPFOnline";
import BackgroundCheckGuide from "./documents/BackgroundCheckGuide";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]); 

  return null;
};

export default function AppRouter() {
  return (
    <Router>
      <div className="layout">
        <Navbar />
        <div className="content">
          <ScrollToTop /> 
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/specialists" element={<Specialists />} />
            <Route path="/specialist/:name" element={<SpecialistDetails />} />
            <Route path="/addcontact" element={<AddContact />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/news" element={<News />} />
            <Route path="/tourism" element={<Tourism />} />
            <Route path="/lifehacks" element={<Lifehacks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<DonationComponent />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/lifehacks" element={<ArticlesPage />} />
            <Route path="/lifehacks/brazil-relocation" element={<EntryRulesBrazil />} />
            <Route path="/lifehacks/florianopolis-lifehacks" element={<FlorianopolisLifeHacks />} />
            <Route path="/lifehacks/maternity-hospital" element={<MaternityHospitals />} />
            <Route path="/lifehacks/water-quality" element={<BeachWaterQuality />} />
            <Route path="/documents/visa-extension" element={<VisaExtension />} />
            <Route path="/documents/child-citizenship" element={<ChildCitizenshipBrazil />} />
            <Route path="/documents/sus" element={<SUSGuide />} />
            <Route path="/documents/driver-license" element={<DriverLicenseBrazil />} />
            <Route path="/documents/pet" element={<PetTravelGuide />} />
            <Route path="/documents/cpf" element={<CPFOnlineInstructions />} />
            <Route path="/documents/background" element={<BackgroundCheckGuide />} />

            <Route path="/lifehacks/for-child" element={<ForChild />} />
            <Route path="/tourism/floripa-guide" element={<FloripaGuide />} />
            <Route path="/tourism/floripa-locations" element={<FloripaLocationsGuide />} />
            <Route path="/tourism/sitio-do-morango" element={<SitioDoMorango />} />
            <Route path="/tourism/balneario-camborio" element={<Balneario />} />
            <Route path="/tourism/beto-carrero" element={<BetoCarreroArticle />} />
            <Route path="/weather" element={<WeatherWidget />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}